import { render, staticRenderFns } from "./Checkout.vue?vue&type=template&id=599275b7&"
import script from "./Checkout.vue?vue&type=script&lang=js&"
export * from "./Checkout.vue?vue&type=script&lang=js&"
import style0 from "./Checkout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BContainer} from 'bootstrap-vue'
    installComponents(component, {BContainer})
    

export default component.exports